<template>
  <sc-render :fields="fields" :empty-message="$t('NO_DATA_SOURCE_EXIST')">
    <section class="editorial-quote-container" :class="themeClass">
      <sc-text v-if="isEditMode || hasTitle" tag="h2" :field="fields.title" />
      <sc-rich-text tag="p" class="description" :field="description" />
      <sc-text v-if="isEditMode || hasTag" tag="p" class="tag" :field="fields.tag" />
      <editorial-cta :fields="fields" />
    </section>
  </sc-render>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Text, RichText } from '@sitecore-jss/sitecore-jss-vue'
import get from '~/helpers/get'
import ScRender from '../sc-render'
import EditorialCta from '../editorial-cta'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'EditorialQuote',
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    ScRender,
    ScText: Text,
    ScRichText: RichText,
    EditorialCta
  },
  computed: {
    ...mapJssGetters(['isEditMode', 'colorTheme']),
    themeClass () {
      return `theme-${this.colorTheme}`.toLowerCase()
    },
    hasTitle () {
      return !!get(this.fields, 'title.value')
    },
    hasTag () {
      return !!get(this.fields, 'tag.value')
    },
    description () {
      return get(this.fields, 'description', {})
    }
  }
}
</script>

<style lang="scss" scoped>
.editorial-quote-container {
  padding: 0 $space-050;
  margin-bottom: $space-090;
}

h2 {
  @include font('060');
  @include stack-space($space-050);
}

.description {
  @include font('080')
}

.tag {
  @include font('040');
  color: $color-gray;
  margin-top: $space-050;
}

@include tablet {
  .editorial-quote-container {
    padding: 0 $space-060;
    margin-bottom: $space-100;
  }

  h2 {
    @include font('090');
    @include stack-space($space-030);
  }

  .description {
    @include font('100');
  }

  .tag {
    margin-top: $space-070;
  }
}

.theme-black {
  .editorial-quote-container {
    @include outline-focus($color-white);
  }

  .description, .text {
    color: $color-white;
  }
}
</style>
